import * as rmd from 'material-ui';
import React from 'react';

class EnumPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: this.props.value
        };
    }

    handleValueChange = (e, key, payload) => {
        var propKey = this.props.propKey;
        this.props.onChange(propKey, payload);

        this.setState({ value: payload });
    };

    renderOption(option) {
        return (
            <rmd.MenuItem
                key={option.value || option}
                value={option.value || option}
                primaryText={option.text || option}
            />
        );
    }

    render() {
        return (
            <div>
                <rmd.SelectField
                    floatingLabelText={this.props.label}
                    value={this.state.value}
                    onChange={this.handleValueChange}
                >
                    {this.props.options.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default EnumPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/EnumPicker.js
 **/